// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1OO8C","row":"styles_row__-mo8M","moreInfo":"styles_moreInfo__1OrsU","table":"styles_table__3506g","containerRows":"styles_containerRows__CRXlY"};